export const nonLenderIds = ['anywhere', 'ownUp'];
